module.exports = __webpack_public_path__ + "img/welcome-coins.577eebcc.png";